module.exports = __webpack_public_path__ + "static/media/card11.2e6fe073.png";